export default __webpack_public_path__ + "static/media/mobile_13.e4448aed.png";